var map = {
	"../pages/account/account.module": [
		582,
		14
	],
	"../pages/chat/chat.module": [
		583,
		13
	],
	"../pages/games/games.module": [
		584,
		12
	],
	"../pages/gatchas/gatchas.module": [
		585,
		11
	],
	"../pages/home/home.module": [
		586,
		10
	],
	"../pages/login/login.module": [
		587,
		9
	],
	"../pages/machine/machine.module": [
		588,
		8
	],
	"../pages/profile/profile.module": [
		589,
		7
	],
	"../pages/settings/settings.module": [
		590,
		6
	],
	"../pages/shop/shop.module": [
		591,
		5
	],
	"../pages/signin/signin.module": [
		592,
		0
	],
	"../pages/singleGame/singleGame.module": [
		593,
		4
	],
	"../pages/splash/splash.module": [
		594,
		3
	],
	"../pages/trophies/trophies.module": [
		595,
		2
	],
	"../pages/variant/variant.module": [
		596,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 189;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 189
// module chunks = 15